import {
    Component,
    EventEmitter,
    Output,
    ViewEncapsulation,
    ViewChild,
    OnInit,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LegalDialogComponent } from '../../dialogs/legal-dialog/legal-dialog.component';
import { CreateBusinessAccountFormData } from '../../model/form-data';
import { CreateAddressSectionComponent } from '../create-address-section/create-address-section.component';
import { CreateProfileComponentService } from '../../services/create.profile.component.service';
import { TaxType } from '@viewbid/ts-angular-client';

@Component({
    selector: 'vb-create-charity-profile',
    templateUrl: './create-charity-profile.component.html',
    styleUrls: ['./create-charity-profile.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class CreateCharityProfileComponent implements OnInit {
    isFormValid = true;
    charityProfileFormGroup = this._formBuilder.group({
        charityName: ['', Validators.required],
        businessRepName: ['', Validators.required],
        charityNumber: ['', Validators.required],
    });

    @Output() submitCharityProfileFormData =
        new EventEmitter<CreateBusinessAccountFormData>();
    @ViewChild('addressSection')
    private addressSection!: CreateAddressSectionComponent;
    constructor(
        private _formBuilder: FormBuilder,
        private dialog: MatDialog,
        private createProfileComponentService: CreateProfileComponentService,
    ) {}

    ngOnInit(): void {
        this.charityProfileFormGroup.valueChanges.subscribe(() => {
            this.isFormValid = this.validate();
        });
    }

    addressSectionValueChanges(): void {
        this.isFormValid = this.validate();

        this.createProfileComponentService.setFormValidity(this.isFormValid);
    }

    onSubmit(): void {
        this.isFormValid = this.validate();
        if (this.isFormValid) {
            this.submitCharityProfileFormData.emit({
                name:
                    this.charityProfileFormGroup.controls['charityName']
                        .value ?? '',
                taxType: TaxType.None,
                representativeFullName:
                    this.charityProfileFormGroup.controls['businessRepName']
                        .value ?? '',
                businessNumber:
                    this.charityProfileFormGroup.controls['charityNumber']
                        .value ?? '',
                postalCode:
                    this.addressSection.addressFormGroup.controls['postalCode']
                        .value,
                city: this.addressSection.addressFormGroup.controls['city']
                    .value,
                country:
                    this.addressSection.addressFormGroup.controls['country']
                        .value,
                address1:
                    this.addressSection.addressFormGroup.controls['address1']
                        .value,
                address2:
                    this.addressSection.addressFormGroup.controls['address2']
                        .value,
                province:
                    this.addressSection.addressFormGroup.controls['province']
                        .value,
                phoneNumber:
                    this.addressSection.addressFormGroup.controls['phoneNumber']
                        .value,
                phoneNumberExt: '',
                buzzer: '',
            });
        }
    }

    validate(): boolean {
        this.addressSection.markAllAsTouched();
        this.charityProfileFormGroup.markAllAsTouched();

        return (
            this.charityProfileFormGroup.valid &&
            this.addressSection.isFormValid()
        );
    }

    openDialog(): void {
        this.dialog.open(LegalDialogComponent);
    }
}
